import { connect } from 'react-redux';
import { actions } from '../../../../../redux/modules/talleres';
import Listar from './Tabs';


const ms2p = (state) => {
    return {
        ...state.talleres,
    };
};

const md2p = { ...actions };

export default connect(ms2p, md2p)(Listar);
